import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'

interface CashRegisterWarningModalProps {
  isOpen: boolean
  onCloseRegister: () => void
  onLogoutAnyway: () => void
  onCancel: () => void
}

const CashRegisterWarningModal: React.FC<CashRegisterWarningModalProps> = ({
  isOpen,
  onCloseRegister,
  onLogoutAnyway,
  onCancel
}) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            Cash Register is Open
          </h2>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="mb-6">
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            The cash register is currently open. Please close it before logging out to ensure proper accounting and security.
          </p>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-700 rounded-md p-3">
            <p className="text-sm text-yellow-800 dark:text-yellow-200">
              <strong>Note:</strong> Closing the register will record the closing cash amount and finalize today's session.
            </p>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onLogoutAnyway}
            className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors"
          >
            Logout Anyway
          </button>
          <button
            onClick={onCloseRegister}
            className="flex-1 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            Close Register
          </button>
        </div>
      </div>
    </div>
  )
}

export default CashRegisterWarningModal


